import { defineAsyncComponent } from 'vue'

export const iconModules = import.meta.glob('/src/assets/icons/**/*.svg')

/* #116071 Memoized async icon components: return the SAME component instance per icon
   path so `:is`/`<component>` identity stays stable across re-renders. Building
   defineAsyncComponent(iconModules[...]) inline on every render creates a new component
   identity, remounting the icon and making it blink (e.g. list/search icons while typing). */
const iconComponentCache = {}

export const getIconComponent = (path) => {
	if (!iconComponentCache[path]) {
		const loader = iconModules[path]
		if (!loader) return null
		iconComponentCache[path] = defineAsyncComponent(loader)
	}
	return iconComponentCache[path]
}
